var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefectsNotAddressed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14ZM7 8.75C7.48398 8.75 7.875 9.14102 7.875 9.625C7.875 10.109 7.48398 10.5 7 10.5C6.51602 10.5 6.125 10.109 6.125 9.625C6.125 9.14102 6.51602 8.75 7 8.75ZM7 3.5C7.49766 3.5 7.89414 3.92383 7.85859 4.42148L7.65625 7.26523C7.63164 7.60977 7.34453 7.875 7.00273 7.875C6.6582 7.875 6.37383 7.60977 6.34922 7.26523L6.14687 4.42148C6.11133 3.92383 6.50508 3.5 7.00547 3.5H7Z",
    fill: "#9F555D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectsNotAddressed);
export default __webpack_public_path__ + "static/media/DefectsNotAddressed.8eb627844b282ef5a27c5532875cc0aa.svg";
export { ForwardRef as ReactComponent };